/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { Bell, X } from "lucide-react";
import NotificationPanel from "./NotificationPanel";
import useNotifications from "./useNotifications";
import "./NotificationBell.css";

const TOAST_TTL = 5000;

function ArrivalToast({ count, onOpen, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, TOAST_TTL);
    return () => clearTimeout(t);
  }, [count, onDismiss]);

  const label = count === 1 ? "1 new notification" : `${count} new notifications`;
  return (
    <div className="vsn-arrival-toast" role="status" aria-live="polite">
      <button
        type="button"
        className="vsn-arrival-toast-body"
        onClick={() => { onOpen(); onDismiss(); }}
      >
        <Bell size={14} className="vsn-arrival-toast-icon" />
        <span>{label}</span>
      </button>
      <button
        type="button"
        className="vsn-arrival-toast-close"
        aria-label="Dismiss"
        onClick={onDismiss}
      >
        <X size={12} />
      </button>
    </div>
  );
}

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const bell = useNotifications({ pageSize: 8 });

  // When the dropdown opens, fetch the latest 8 rows fresh.
  useEffect(() => {
    if (open) bell.refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Dismiss the arrival toast when the bell opens.
  useEffect(() => {
    if (open && bell.arrivedCount > 0) bell.dismissArrived();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Close on outside click.
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  // Close on Esc.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  const badge =
    bell.unreadCount === 0
      ? null
      : bell.unreadCount > 9
      ? "9+"
      : String(bell.unreadCount);

  return (
    <>
      <div className="vsn-bell-wrap" ref={wrapRef}>
        <button
          type="button"
          className="vsa-icon-btn vsn-bell-btn"
          aria-label={`Notifications${badge ? ` (${badge} unread)` : ""}`}
          title="Notifications"
          onClick={() => setOpen((v) => !v)}
        >
          <Bell size={18} />
          {badge && <span className="vsn-bell-badge">{badge}</span>}
        </button>
        {open && (
          <NotificationPanel
            bell={bell}
            onClose={() => setOpen(false)}
          />
        )}
      </div>
      {bell.arrivedCount > 0 && !open && (
        <ArrivalToast
          count={bell.arrivedCount}
          onOpen={() => setOpen(true)}
          onDismiss={bell.dismissArrived}
        />
      )}
    </>
  );
}
